import React from 'react';
import cn from 'classnames';

const ICON_HEADER_CLASS = 'h-4 w-4 shrink-0 text-chart-2';

export function CardShell({ className, children, ...rest }) {
  return (
    <div
      className={cn(
        'dashboard-card flex min-h-0 w-full flex-col border border-border bg-white text-foreground',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

export function CardHeaderRow({ title, icon: Icon, className }) {
  return (
    <div
      className={cn(
        'flex shrink-0 items-center gap-2 border-b border-border px-4 pb-2.5 pt-4',
        className,
      )}
    >
      <Icon className={ICON_HEADER_CLASS} strokeWidth={2} />
      <h3 className='text-sm font-semibold tracking-tight text-foreground'>{title}</h3>
    </div>
  );
}
